// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/ddt/mall/css/" + chunkId + "." + "19a5aed3" + ".css";
};